// extracted by mini-css-extract-plugin
module.exports = {"sticker__animation":"sticker_sticker__animation__sL2qB","sticker-animation":"sticker_sticker-animation__qmSUU"};